import { FC } from 'react'

import { Navigate } from 'react-router-dom'
import styled from 'styled-components'

import { ArtistContactDetailsForm } from 'src/Components/ArtistContactDetailsForm'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { PublicRoutesEnum } from 'src/Router/PublicComponentsNewUI'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'

import { NoAuthPageLayout } from '../../Components/NoAuthPageLayout'
import { CreateCampaignBreadcrumbsNoAuth } from '../../Components/CreateCampaignBreadcrumbsNoAuth'
import { HelmetTitle } from '../../Components/HelmetTitle'
import { useArtistRegisterPage } from '../ArtistRegisterPage/useArtistRegisterPage'

import { PreReleaseArtistDetails } from './Components/PreReleaseArtistDetails'

const Container = styled.div`
  display: flex;
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    gap: 40px;
  }
`

const ContentContainer = styled.div`
  display: flex;
  padding: 24px 40px 24px 24px;
  justify-content: center;
  align-items: center;
  gap: 40px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background-color: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    border: none;
    box-shadow: none;
    padding: 0;
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
`

const StyledArtistContactDetailsForm = styled(ArtistContactDetailsForm)`
  flex-basis: calc(50% - 48px);

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    flex-basis: unset;
  }
`

export const ArtistRegisterPagePreRelease: FC = () => {
  const { search } = useCustomSearchParams()
  const {
    handleSubmit,
    onGoogleClick,
    isEmailExist,
    clearEmailExist,
    loading,
    onStartFillingForm,
    preReleaseSignUpState,
  } = useArtistRegisterPage()

  if (!preReleaseSignUpState) {
    return (
      <Navigate
        replace
        to={`${PublicRoutesEnum.CreatePreReleaseTrackDetails}?${search.toString()}`}
      />
    )
  }

  const { artist } = preReleaseSignUpState

  return (
    <NoAuthPageLayout>
      <HelmetTitle />

      <Container>
        <CreateCampaignBreadcrumbsNoAuth
          platform={CampaignPlatformTypeEnum.SPOTIFY}
        />
        <ContentContainer>
          <StyledArtistContactDetailsForm
            onSubmit={handleSubmit}
            onGoogleClick={onGoogleClick}
            isEmailExist={isEmailExist}
            clearEmailExist={clearEmailExist}
            onStartFillingForm={onStartFillingForm}
            loading={loading}
          />
          <PreReleaseArtistDetails
            artistName={artist.name}
            followersCount={artist.followersCount ?? 0}
            photoUrl={artist.photoUrl}
          />
        </ContentContainer>
      </Container>
    </NoAuthPageLayout>
  )
}
